<template>
  <div>
    <h2 class="text-center">咨询同意书</h2>
    <el-card class="box-card">
      <div class="rich-text">
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >亲爱的同学：</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >你好！为了保障你的权益，在预约之前，有一些关于咨询的重要事项和约定需要你了解，请认真阅读以下内容，确认你已明白无误且完全同意后，才能进行预约。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >1.&nbsp;尊重：咨询的形式以及是否开始或终止咨询、咨询关注的主题均由你本人决定。咨询师只能提出建议，无权强硬要求。相应地，随意终止咨询给自己或咨询过程带来的不良影响也由来访者本人承担。咨询过程中，若对于咨询的方向和目标存有异议，可与咨询师进行必要的讨论并调整。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >2.&nbsp;坦诚：咨询师需要坦诚的进行倾听和对话。你的任何感受、想法、意见和建议都可以及时地与咨询师直接沟通，这样你们彼此之间才能建立更温馨的合作关系。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >3.&nbsp;行动：你是咨询的主角。咨询师可以提供的帮助包括陪伴、倾听、理解、反馈、建议。咨询师会鼓励你积极采取行动，因为生活是你采取行动或者不采取行动的结果。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(254,128,135,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >4.&nbsp;</span>
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(254,128,135,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >时间：你和咨询师须遵守事先约定的咨询时间，准时出席。若需取消，请在前一天晚上20点前在本系统上取消，取消成功后你会收到短信通知。如果迟到，咨询时间一般不会顺延；迟到超过30分钟咨询将会取消并被记为爽约。已经预约成功但没有任何通知爽约不来的情况，可能会降低你以后预约的优先级。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >5.&nbsp;保密：咨询师会对你所提供的信息及咨询过程中的基本信息完全保密；如果需要录音或录像，咨询师征得你的书面同意后方可进行。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >6.&nbsp;保密例外：如果出现以下情况，则不能遵循保密原则：</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >（1）如果出现自我伤害或者伤害他人的倾向，那么咨询师有必要通知相关人员采取必要的措施。</span>
        </p>
        <p style="line-height:0; margin-bottom:5px;">
          <span
            class="--mb--rich-text"
            data-boldtype="0"
            style="font-family:PingFangSC; font-weight:400; font-size:12px; color:rgba(52,60,109,1); font-style:normal; letter-spacing:0px; line-height:18px; text-decoration:none;"
          >（2）如果谈论的主题涉及法律责任，如有必要，咨询师将信息呈交有关部门。</span>
        </p>
      </div>
    </el-card>
    <el-checkbox v-model="agree" >我已阅读并同意</el-checkbox>
    <br>
    <br>
    <el-button type="primary" round style="width:100%" :disabled="!agree" @click="goappointStep2">我要预约</el-button>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agree: false,
    };
  },
  mounted() {
    document.title = '我要预约'
  },
  methods: {
    goappointStep2() {
      this.$router.push('appointStep2');
    },
  }
};
</script>

<style scoped>
</style>
